var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipoDeUsuarios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2633D8"
    },
    d: "M120.433,139.63c12.853,0,23.273-10.42,23.273-23.273V93.085H256h112.294v23.273 c0,12.853,10.42,23.273,23.273,23.273c12.853,0,23.273-10.42,23.273-23.273V69.812c0-12.853-10.42-23.273-23.273-23.273H279.273 v-23.26c0-12.853-10.42-23.273-23.273-23.273c-12.853,0-23.273,10.42-23.273,23.273v23.26H120.433 c-12.853,0-23.273,10.42-23.273,23.273v46.545C97.161,129.21,107.58,139.63,120.433,139.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC27B"
    },
    d: "M120.433,182.108c-38.498,0-69.818,31.32-69.818,69.818s31.32,69.818,69.818,69.818 s69.818-31.32,69.818-69.818S158.933,182.108,120.433,182.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5286FA"
    },
    d: "M120.433,368.289C54.025,368.289,0,422.315,0,488.721c0,12.853,10.42,23.273,23.273,23.273h97.161 h97.159c12.853,0,23.273-10.42,23.273-23.273C240.865,422.315,186.84,368.289,120.433,368.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECB45C"
    },
    d: "M50.615,251.926c0,38.498,31.32,69.818,69.818,69.818V182.108 C81.936,182.108,50.615,213.428,50.615,251.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6DEB"
    },
    d: "M0,488.721c0,12.853,10.42,23.273,23.273,23.273h97.161V368.289C54.025,368.289,0,422.315,0,488.721z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC27B"
    },
    d: "M391.567,182.108c-38.498,0-69.818,31.32-69.818,69.818s31.32,69.818,69.818,69.818 s69.818-31.32,69.818-69.818S430.064,182.108,391.567,182.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00E7F0"
    },
    d: "M391.567,368.289c-66.406,0-120.432,54.025-120.432,120.432c0,12.853,10.42,23.273,23.273,23.273 h97.159h97.161c12.853,0,23.273-10.42,23.273-23.273C512,422.315,457.975,368.289,391.567,368.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECB45C"
    },
    d: "M321.749,251.926c0,38.498,31.32,69.818,69.818,69.818V182.108 C353.067,182.108,321.749,213.428,321.749,251.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00D7DF"
    },
    d: "M271.135,488.721c0,12.853,10.42,23.273,23.273,23.273h97.159V368.289 C325.16,368.289,271.135,422.315,271.135,488.721z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipoDeUsuarios);
export default __webpack_public_path__ + "static/media/tipo_de_usuarios.f9055d14fe6dd04f79fea8dda0d87b00.svg";
export { ForwardRef as ReactComponent };